import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { CSSProperties } from "react"
import { Select } from "antd"

export type SingeChoicePickerItem = {
    id: Maybe<string>
    title: string
    disabled?: boolean
}

type Props = {
    data: SingeChoicePickerItem[]
    selectedItemId?: Maybe<string>
    onItemSelected: (id: Maybe<string>) => void
    placeHolder?: Maybe<string>
    style?: Record<string, any>
    showSearch?: boolean
}

class SingleChoicePicker extends React.PureComponent<Props> {
    onItemSelected = (key: Maybe<string>) => {
        this.props.onItemSelected(key)
    }

    render() {
        if (this.props.data.length === 1) {
            return null
        }

        return (
            <div style={styles.container}>
                <Select
                    style={{
                        minWidth: "12rem",
                        ...this.props.style,
                    }}
                    showSearch={this.props.showSearch}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        // @ts-expect-error
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    value={this.props.selectedItemId || this.props.placeHolder || "Select Item"}
                    onChange={this.onItemSelected}
                    placeholder={this.props.placeHolder || "Select Item"}>
                    {this.props.data.map(l => (
                        // @ts-expect-error
                        <Select.Option key={l.id} value={l.id}>
                            {l.title}
                        </Select.Option>
                    ))}
                </Select>
            </div>
        )
    }
}

const styles: Record<string, CSSProperties> = {
    container: {
        position: "relative",
        zIndex: 10,
    },
}
export default SingleChoicePicker
